'use client';
import { Suspense } from 'react';
import HeroSection from '@/app/HeroSection';
import ProblemSection from '@/app/ProblemSection';
import HubGovernancaSection from '@/app/HubGovernancaSection';
import SolutionsSection from '@/app/SolutionsSection';
import DashboardSection from '@/app/DashboardSection';
import ClientsSection from '@/app/ClientsSection';
import ProcessSection from '@/app/ProcessSection';
import StrategicPartnershipSection from '@/app/StrategicPartnershipSection';
import CaseStudySection from '@/app/CaseStudySection';
import TestimonialsSection from '@/app/TestimonialsSection';
import FAQSection from '@/app/FAQSection';
import Footer from '@/app/Footer';
import Header from '@/app/components/common/Header';

export default function HomePage() {
  return (
    <Suspense fallback={null}>
      <main className="bg-[#02020c] min-h-screen">
        <div className="w-full bg-[url('/images/img_group_94.png')] bg-cover bg-center bg-no-repeat relative">
          {/* Header Section */}
          <div className="w-full relative z-10">
            <div className="pt-[33px] sm:pt-[44px] lg:pt-[66px] px-4 max-w-7xl mx-auto">
              <Header />
            </div>
          </div>
          
          {/* Hero Section with Background */}
          <HeroSection />
        </div>

        {/* Hub de Governança — Video Section */}
        <HubGovernancaSection />

        {/* Problem Section */}
        <ProblemSection />

        {/* Solutions Section */}
        <SolutionsSection />

        {/* Dashboard Section */}
        <DashboardSection />

        {/* Clients Section */}
        <ClientsSection />

        {/* Process Section */}
        <ProcessSection />

        <StrategicPartnershipSection />

        {/* Case Study Section */}
        <CaseStudySection />

        {/* Testimonials Section */}
        <TestimonialsSection />

        {/* FAQ Section */}
        <FAQSection />

        {/* Footer */}
        <Footer />
      </main>
    </Suspense>
  )
}
